export default __webpack_public_path__ + "static/EverydayBannerBg-43d332f9b4ddbf1f08a13c984e6a116f.png";